import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PurchasePartTypeService } from 'pages/system-fields/purchase-part-types/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PurchasePartTypeService, DialogService, EventAggregator)
export class PurchasePartTypes {
    constructor(purchasePartTypeService, dialogService, ea) {
        this.ea = ea;
        this.purchasePartTypeService = purchasePartTypeService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('purchase-part-types:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (purchasePartType) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.purchasePartTypeService.delete(purchasePartType.id);
                this.grid.refresh();
                toastr.success('Purchase part type was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.purchasePartTypeService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.purchasePartTypeService.editor, model: { id: data.id } });
    };
}